import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

// Internet audio uses the accepted consultation room, with an explicit camera-off intent.
// Keep intent in the URL as well as state so a refresh cannot turn the camera on.
export default function AppointmentCall() {
  const { id } = useParams();
  const location = useLocation();

  return (
    <Navigate
      to={`/appointments/video/${String(id || "").trim()}?media=audio`}
      replace
      state={{ ...(location.state || {}), mediaKind: "audio" }}
    />
  );
}
